import { type BaseInputProps, Input } from '@ctct/summit-core';
import { type InputHTMLAttributes } from 'react';
import { useFormContext } from 'react-hook-form';

import { type InputOpts } from '../../types';
import { getDisableAutofillProps } from '../../utils';

const TextInput = ({
  formKey,
  registerOpts,
  onChange,
  shouldDisableAutofill = false,
  ...inputProps
}: InputOpts
  & InputHTMLAttributes<HTMLInputElement>
  & Pick<
    BaseInputProps,
    'startAdornment' | 'endAdornment' | 'hasError' | 'shouldHideStatusIcon'
  > & {
    shouldDisableAutofill?: boolean;
  }) => {
  const { register } = useFormContext();
  const { onChange: registeredOnChange, ...restRegisterOpts } = register(formKey, registerOpts);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    registeredOnChange(event);
    onChange?.(event);
  };
  return (
    <Input
      {...getDisableAutofillProps(shouldDisableAutofill)}
      {...restRegisterOpts}
      {...inputProps}
      onChange={handleOnChange}
    />
  );
};

export { TextInput };
